module.exports = __webpack_public_path__ + "static/media/billing-info.35382207.png";